export const NotFound: React.FC = () => {
  return (
    <div>
      <p>Not Found</p>
    </div>
  );
};
